import $ from 'jquery';
import 'owl.carousel';

class Partners {
  constructor() {
    this.partners();
    this.partnersCarouselInit();
  }

  activateRandomTab() {
    this.randomTab = this.partnersFilters.data('random-tab');

    if (this.randomTab === 'all') {
      return;
    }

    const tabLink = this.partnersFilters.find(
      `.js-brp-filter[href="#${this.randomTab}"]`,
    );

    if (tabLink.length) {
      setTimeout(() => {
        tabLink.trigger('click');
      }, 10);
    }
  }

  partners() {
    this.partnersBlock = $('.js-brp');

    if (!this.partnersBlock.length) {
      return;
    }

    this.partnersFilters = this.partnersBlock.find('.js-brp-filters');
    this.partnersFilter = this.partnersFilters.find('.js-brp-filter');
    this.partnersList = this.partnersBlock.find('.js-brp-list');
    this.partnersListItems = this.partnersList.find('.js-brp-list-item');
    this.partnersListHeading = this.partnersBlock.find('.js-brp-list-heading');
    this.partnersColumns = this.partnersList.data('brp-columns') || 6;

    this.activateRandomTab();

    this.partnersHeight(this.partnersColumns);

    if (this.partnersFilter.length) {
      this.partnersFilter.on('click', e => {
        e.preventDefault();

        const self = $(e.currentTarget);
        const activeClass = 'is-active';
        const isActive = self.hasClass(activeClass);

        if (isActive) {
          return;
        }

        this.partnersList.removeAttr('style');
        const startingHeight = this.partnersList.outerHeight();
        // this.partnersList.css({ height: startingHeight });

        const type = self.attr('href').substr(1);
        const typeItems = this.partnersList.find(
          `.js-brp-list-item[data-brp-item="${type}"]`,
        );

        this.partnersListItems
          .removeClass('is-animated')
          .fadeOut(200)
          .promise()
          .done(() => {
            if (type === 'all') {
              // this.partnersListItems.addClass('is-animated').fadeIn();
              this.partnersListItems.show().css({ opacity: 0 });
            } else {
              // typeItems.addClass('is-animated').fadeIn();
              typeItems.show().css({ opacity: 0 });
            }

            const endingHeight = this.partnersList.outerHeight();
            const heading = self.attr('data-heading') || self.text();

            this.partnersList.css({ height: startingHeight });
            this.partnersHeight(this.partnersColumns);

            this.partnersListHeading.stop().animate({ opacity: 0 }, 100, () => {
              this.partnersList
                .stop()
                .animate({ height: endingHeight }, 300, () => {
                  if (type === 'all') {
                    this.partnersListItems
                      .css({ opacity: 1 })
                      .addClass('is-animated');
                  } else {
                    typeItems.css({ opacity: 1 }).addClass('is-animated');
                  }

                  this.partnersList.css({ height: '' });

                  this.partnersListHeading
                    .text(heading)
                    .stop()
                    .animate({ opacity: 1 }, 300);
                });
            });

            this.partnersFilter.removeClass('is-active');
            this.partnersFilter.attr('aria-current', false);
            self.addClass('is-active');
            self.attr('aria-current', true);
          });
      });
    }
  }

  partnersCarouselInit() {
    this.carousel = $('.js-restoration-partners-carousel');

    if (!this.carousel.length) {
      return;
    }

    this.carousel.each((index, elem) => {
      this.partnersCarousel = $(elem);
      const carouselColumns = this.partnersCarousel.data('brpc-columns') || 6;
      const carouselLoop = this.partnersCarousel.data('brpc-loop') || 'no';
      const carouselAutoplay =
        this.partnersCarousel.data('brpc-autoplay') || 'no';
      const carouselAutoplayTimeout =
        this.partnersCarousel.data('brpc-autoplay-timeout') || 5000;
      const carouselSpeed = this.partnersCarousel.data('brpc-speed') || 2000;

      this.partnersCarousel.on('initialized.owl.carousel', () => {
        this.carouselPartnersHeight(carouselColumns);
      });

      this.partnersCarousel.owlCarousel({
        items: 1,
        nav: true,
        navText: [
          '<span>Go to previous slide</span>',
          '<span>Go to next slide</span>',
        ],
        slideTransition: 'ease-in-out',
        autoplaySpeed: carouselSpeed,
        navSpeed: carouselSpeed,
        dotsSpeed: carouselSpeed,
        dragEndSpeed: carouselSpeed,
        autoplay: carouselAutoplay === 'yes',
        autoplayTimeout: carouselAutoplayTimeout,
        autoplayHoverPause: true,
        loop: carouselLoop === 'yes',
        responsive: {
          0: {
            autoHeight: true,
          },
          640: {
            autoHeight: false,
          },
        },
      });
    });
  }

  carouselPartnersHeight(columns) {
    const carouselPages = this.partnersCarousel.find('.js-c-brpc-page');

    if (carouselPages.length) {
      carouselPages.each((index, elem) => {
        const page = $(elem);
        const partnersListItems = page.find('.js-brpc-item:visible');

        this.partnersHeight(columns, partnersListItems);
      });
    }
  }

  partnersHeight(columns, customListItems) {
    const partnersListItems =
      customListItems || this.partnersList.find('.js-brp-list-item:visible');

    for (let i = 0; i < partnersListItems.length; i += columns) {
      const elements = partnersListItems.slice(i, i + columns);

      const heights = elements
        .map((index, elem) => {
          const name = $(elem).find('.js-partner-name');

          return name.length ? name.outerHeight() : 0;
        })
        .get();

      const height = Math.max(...heights);

      elements.find('.js-partner-name').css({ 'min-height': height });
    }
  }
}

export default new Partners();



// WEBPACK FOOTER //
// ./src/scripts/modules/partners.js